import createReducer from '../../utils/createReducer';
import actions from './actions';

const actionHandlers = {};

export const initialState = {
    isOpen: false,
    boardId: null,
    hitTotal: null,
    idx: null,
    listingId: null,
};

actionHandlers[actions.MODAL_OPEN] = (state, {payload}) => {
    const isOpen = true;
    const {boardId, listingId, hitTotal, idx} = payload;
    return {
        ...state,
        boardId,
        isOpen,
        listingId,
        hitTotal,
        idx
    };
};

actionHandlers[actions.MODAL_CLOSE] = () => initialState;

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing-delete-modal/reducer.js